// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"145ee0d6","455":"08161174","488":"fc7efc41","720":"e7350226","908":"ee95ac13","977":"240addac"}[chunkId] + ".chunk.js";
};